(function () {
  'use strict';

  const MOBILE_MQ = '(max-width: 989px)';
  const PANEL_MS = 520;
  const OVERLAY_MS = 280;
  const OVERFLOW_PAD = 24;
  const MIN_SUB_HEIGHT = 80;

  const SEL = Object.freeze({
    root: '.header__autify-mega-menu-nav',
    toggle: '.mobile-menu-toggle',
    externalToggle: '#autify-details-menu-drawer-container',
    drawer: '.autify-drawer',
    close: '.drawer-close',
    menu: '.nav-parents',
    dropdown: '.nav-parent--dropdown',
    dropdownParent: '.nav-parent--dropdown',
    navParent: '.nav-parent.has-children',
    navToggle: '.autify-nav-menu__toggle',
    navItem: '.autify-nav-menu__item--has-children',
    navOpen: '.autify-nav-menu__item--has-children.is-open',
    navClosing: '.autify-nav-menu__item--has-children.is-closing',
    navActive: '.autify-nav-menu__item--has-children.is-open, .autify-nav-menu__item--has-children.is-closing',
    dimmed: '.autify-nav-menu__item--sibling-dimmed',
    titledActive: '.child-column--has-title.active',
    sub: '.autify-nav-menu__sub',
    panel: '.autify-nav-menu__sub-panel',
    row: '.autify-nav-menu__row',
    focusable: '.autify-nav-menu__toggle:focus, .autify-nav-menu__parent-link:focus, .autify-nav-menu__link:focus',
    childWrapper: '.child-wrapper',
    wrapperContainer: '.child-wrapper-container',
    wrapperInner: '.child-wrapper-inner',
    navMenu: '.autify-nav-menu',
    navMenuItem: '.autify-nav-menu__item',
    navMenuInColumn: '.child-column--nav-menu .child-content--nav-menu > .autify-nav-menu',
    navContent: '.child-content--nav-menu',
    colOverlay: '.autify-nav-menu__col-overlay',
    colOverlayToggle: '.autify-nav-menu__col-overlay .autify-nav-menu__toggle',
    parentLink: '.nav-parent.has-children > a',
    parentToggle: '.nav-parent__toggle',
    titledTitle: '.child-column--has-title .child-menu-title',
    headerSection: '.shopify-section-header',
    announcementSection:
      '.shopify-section-group-header-group.announcement-bar-section, .announcement-bar-section',
  });

  const CLS = Object.freeze({
    open: 'is-open',
    closing: 'is-closing',
    scrollable: 'autify-nav-menu__sub--scrollable',
    scrollbarVisible: 'autify-nav-menu__sub--scrollbar-visible',
    dimmed: 'autify-nav-menu__item--sibling-dimmed',
    menuOpen: 'menu-open',
    drawerOpen: 'autify-drawer-open',
    active: 'active',
    navMenu: 'autify-nav-menu',
    instantClose: 'autify-nav-menu__item--instant-close',
    twoCols: 'autify-nav-menu--two-cols',
    overlayOpen: 'autify-nav-menu--overlay-open',
    overlayActive: 'autify-nav-menu__item--overlay-active',
    overlayVisible: 'is-visible',
    overlayLeaving: 'is-leaving',
    layoutLocked: 'autify-dropdown--layout-locked',
    colsAtLock: 'autify-cols-at-lock',
    subOpen: 'nav-parent--sub-open',
    menuActive: 'nav-parent--menu-active',
  });

  const mqMobile = window.matchMedia(MOBILE_MQ);
  const mqReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const inited = new WeakSet();

  const isMobile = () => mqMobile.matches;

  function parts(item) {
    return {
      sub: item.querySelector(SEL.sub),
      btn: item.querySelector(SEL.navToggle),
      panel: item.querySelector(SEL.panel),
      list: item.parentElement,
    };
  }

  function waitPanel(panel, cb) {
    if (!panel) {
      cb();
      return;
    }
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      panel.removeEventListener('transitionend', onEnd);
      clearTimeout(timer);
      cb();
    };
    const onEnd = (ev) => {
      if (ev.target !== panel) return;
      if (ev.propertyName && ev.propertyName !== 'grid-template-rows') return;
      finish();
    };
    const timer = setTimeout(finish, PANEL_MS);
    panel.addEventListener('transitionend', onEnd);
  }

  function getItemColumn(item, list) {
    const listRect = list.getBoundingClientRect();
    const mid = listRect.left + listRect.width / 2;
    const itemRect = item.getBoundingClientRect();
    return itemRect.left + itemRect.width / 2 < mid ? 1 : 2;
  }

  function usesOverlay(list) {
    return !isMobile() && !!list?.closest(SEL.dropdownParent);
  }

  function hasNavOpen(list) {
    return !!list?.querySelector(SEL.navOpen);
  }

  function hasNavClosing(list) {
    return !!list?.querySelector(SEL.navClosing);
  }

  function finishColOverlay(list, onDone) {
    list.classList.remove(CLS.overlayOpen);
    list.querySelectorAll(`.${CLS.overlayActive}`).forEach((el) => el.classList.remove(CLS.overlayActive));
    updateSubOpenState(getNavParent(list));
    onDone?.();
  }

  function closeColOverlay(list, options = {}) {
    if (!list) return;
    const { instant = false, onDone } = options;
    const content = list.closest(SEL.navContent);
    const overlay = content?.querySelector(SEL.colOverlay);

    const finish = () => {
      overlay?.remove();
      finishColOverlay(list, onDone);
    };

    if (!overlay || instant || mqReduced.matches) {
      finish();
      return;
    }

    overlay.classList.remove(CLS.overlayVisible);
    overlay.classList.add(CLS.overlayLeaving);
    let done = false;
    const complete = () => {
      if (done) return;
      done = true;
      overlay.removeEventListener('transitionend', onEnd);
      clearTimeout(timer);
      finish();
    };
    const onEnd = (ev) => {
      if (ev.target !== overlay) return;
      complete();
    };
    const timer = setTimeout(complete, OVERLAY_MS + 40);
    overlay.addEventListener('transitionend', onEnd);
  }

  function openColOverlay(item, list) {
    const content = list.closest(SEL.navContent);
    const row = item.querySelector(SEL.row);
    const sub = item.querySelector(SEL.sub);
    if (!content || !row || !sub) return;

    closeColOverlay(list, { instant: true });

    const col = list.classList.contains(CLS.twoCols) ? getItemColumn(item, list) : 1;
    const overlay = document.createElement('div');
    overlay.className = 'autify-nav-menu__col-overlay';
    overlay.dataset.col = String(col);

    const header = row.cloneNode(true);
    const links = sub.cloneNode(true);
    links.removeAttribute('aria-hidden');
    links.removeAttribute('id');

    overlay.append(header, links);
    content.appendChild(overlay);

    const overlayBtn = overlay.querySelector(SEL.navToggle);
    if (overlayBtn) overlayBtn.setAttribute('aria-expanded', 'true');

    list.classList.add(CLS.overlayOpen);
    item.classList.add(CLS.overlayActive);
    setSubOpen(getNavParent(item), true);

    if (mqReduced.matches) {
      overlay.classList.add(CLS.overlayVisible);
      return;
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(() => overlay.classList.add(CLS.overlayVisible));
    });
  }

  function resetItem(item) {
    const { sub, btn, list } = parts(item);
    item.classList.remove(CLS.open, CLS.closing, CLS.instantClose, CLS.overlayActive);
    if (sub) {
      sub.classList.remove(CLS.scrollable, CLS.scrollbarVisible);
      sub.style.removeProperty('--autify-sub-available');
      sub.setAttribute('aria-hidden', 'true');
    }
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (list && !hasNavOpen(list) && !hasNavClosing(list)) {
      closeColOverlay(list, { instant: true });
    }
    updateSubOpenState(getNavParent(item));
  }

  function clearDimmed(scope) {
    scope.querySelectorAll(SEL.dimmed).forEach((el) => el.classList.remove(CLS.dimmed));
  }

  function setDimmed(list, current, on) {
    if (!list?.classList.contains(CLS.navMenu) || isMobile()) return;
    const children = list.children;
    for (let i = 0; i < children.length; i += 1) {
      const el = children[i];
      if (!el.matches(SEL.navMenuItem)) continue;
      el.classList.toggle(CLS.dimmed, on && el !== current);
    }
  }

  function lockDropdownLayout(node) {
    if (!node?.classList.contains('nav-parent--dropdown') || node.classList.contains(CLS.layoutLocked)) return;

    positionDropdown(null, [node], node);

    const panel = node.querySelector(SEL.wrapperContainer);
    const inner = node.querySelector(SEL.wrapperInner);
    if (!panel || !inner) return;

    const width = panel.offsetWidth;
    const height = inner.offsetHeight;
    if (!width || !height) return;

    panel.style.setProperty('--autify-dropdown-locked-width', `${width}px`);
    panel.style.setProperty('--autify-dropdown-locked-height', `${height}px`);
    node.querySelectorAll(SEL.navMenu).forEach((menu) => {
      menu.setAttribute(`data-${CLS.colsAtLock}`, menu.classList.contains(CLS.twoCols) ? '2' : '1');
    });
    node.classList.add(CLS.layoutLocked);
  }

  function applyLockedCols(list) {
    const dropdown = list.closest(SEL.dropdownParent);
    if (!dropdown?.classList.contains(CLS.layoutLocked)) return false;
    const locked = list.getAttribute(`data-${CLS.colsAtLock}`);
    if (!locked) return false;
    const wantTwo = locked === '2';
    list.classList.toggle(CLS.twoCols, wantTwo);
    if (wantTwo) {
      if (!list.style.getPropertyValue('--autify-nav-two-cols-max')) {
        const rect = list.getBoundingClientRect();
        const available = Math.max(220, Math.floor(window.innerHeight - rect.top - 24));
        list.style.setProperty('--autify-nav-two-cols-max', `${available}px`);
      }
    } else {
      list.style.removeProperty('--autify-nav-two-cols-max');
    }
    return true;
  }

  function clearLockedCols(node) {
    node?.querySelectorAll(SEL.navMenu).forEach((menu) => {
      menu.removeAttribute(`data-${CLS.colsAtLock}`);
    });
  }

  function unlockDropdownLayout(node) {
    if (!node?.classList.contains(CLS.layoutLocked)) return;
    if (node.querySelector(SEL.navOpen)) return;

    const panel = node.querySelector(SEL.wrapperContainer);
    panel?.style.removeProperty('--autify-dropdown-locked-width');
    panel?.style.removeProperty('--autify-dropdown-locked-height');
    clearLockedCols(node);
    node.classList.remove(CLS.layoutLocked);
  }

  function positionDropdown(header, nodes, item) {
    const targets = item ? [item] : nodes;
    for (let i = 0, n = targets.length; i < n; i += 1) {
      const node = targets[i];
      if (node.classList.contains(CLS.layoutLocked)) continue;

      const parentRect = node.getBoundingClientRect();
      const wrap = node.querySelector(SEL.childWrapper);
      const panel = node.querySelector(SEL.wrapperContainer);
      if (!wrap || !panel) continue;

      const lockedWidth = panel.style.getPropertyValue('--autify-dropdown-locked-width');
      const panelWidth = lockedWidth ? parseFloat(lockedWidth) : panel.offsetWidth || wrap.offsetWidth;
      if (!panelWidth) continue;

      const hasTwoColNav = !!node.querySelector('.autify-nav-menu--two-cols');
      const desiredLocalLeft = hasTwoColNav ? parentRect.width / 2 - panelWidth / 2 : 0;
      const desiredGlobalLeft = parentRect.left + desiredLocalLeft;
      const minGlobalLeft = 8;
      const maxGlobalLeft = window.innerWidth - panelWidth - 8;
      const clampedGlobalLeft = Math.max(minGlobalLeft, Math.min(desiredGlobalLeft, maxGlobalLeft));
      const localLeft = clampedGlobalLeft - parentRect.left;

      node.style.setProperty('--dropdown-left', `${Math.round(localLeft)}px`);
    }
  }

  function getNavParent(el) {
    return el?.closest('.nav-parent.has-children') || null;
  }

  function updateSubOpenState(parent) {
    if (!parent) return;
    const stillOpen =
      !!parent.querySelector(SEL.navOpen) ||
      !!parent.querySelector(SEL.navClosing) ||
      !!parent.querySelector('.autify-nav-menu--overlay-open');
    if (!stillOpen) parent.classList.remove(CLS.subOpen);
  }

  function setSubOpen(parent, on) {
    if (!parent) return;
    parent.classList.toggle(CLS.subOpen, on);
  }

  function closeParentMenu(parent) {
    if (!parent) return;
    parent.classList.remove(CLS.subOpen, CLS.menuActive);
    parent.querySelectorAll(SEL.navActive).forEach(resetItem);
    parent.querySelectorAll(SEL.navMenu).forEach((list) => closeColOverlay(list, { instant: true }));
    clearDimmed(parent);
    unlockDropdownLayout(parent);
    parent.querySelectorAll(SEL.focusable).forEach((el) => el.blur());
  }

  class AutifyMegaMenu {
    constructor(root) {
      this.root = root;
      this.scope = root.closest('.header-wrapper') || root;
      this.toggle = this.q(SEL.toggle);
      this.externalToggle = document.querySelector(SEL.externalToggle);
      this.drawer = this.q(SEL.drawer);
      this.closeBtn = this.q(SEL.close);
      this.menu = this.q(SEL.menu);
      this.dropdowns = [...this.qa(SEL.dropdown)];
      this.parents = [];
      this.abort = null;
      this.posFrame = 0;
      this.overflowFrame = 0;
      this.mobileFrame = 0;
      this.leaveTimer = 0;
      this.resizeObserver = null;
      this.colSyncTimer = 0;
      this.headerSection = null;
      this.announcementSection = null;
    }

    refreshLayoutCaches() {
      this.headerSection = document.querySelector(SEL.headerSection);
      this.announcementSection = document.querySelector(SEL.announcementSection);
    }

    q(selector, context = this.root) {
      return context.querySelector(selector);
    }

    qa(selector, context = this.root) {
      return context.querySelectorAll(selector);
    }

    mount() {
      if (!this.drawer || !this.menu) return false;

      this.abort?.abort();
      this.abort = new AbortController();
      const { signal } = this.abort;

      this.parents = [...this.qa(SEL.navParent, this.menu)];

      this.refreshLayoutCaches();
      this.bindLayout(signal);
      this.bindDrawer(signal);
      this.bindNavToggle(signal);
      this.bindDesktop(signal);
      this.bindMobile(signal);
      this.bindViewport(signal);
      this.bindEscape(signal);

      positionDropdown(this.scope, this.dropdowns);
      return true;
    }

    bindLayout(signal) {
      const runPosition = () => {
        cancelAnimationFrame(this.posFrame);
        this.posFrame = requestAnimationFrame(() => {
          if (!isMobile()) positionDropdown(this.scope, this.dropdowns);
        });
      };

      const runOverflow = () => {
        if (isMobile()) return;
        cancelAnimationFrame(this.overflowFrame);
        this.overflowFrame = requestAnimationFrame(() => {
          this.syncAllOpenOverflow();
          this.syncNavMenuColumns();
        });
      };

      const runMobileTogglePosition = () => {
        if (!isMobile() || !this.toggle) return;
        cancelAnimationFrame(this.mobileFrame);
        this.mobileFrame = requestAnimationFrame(() => this.syncMobileTogglePosition());
      };

      const runLayoutSync = () => {
        runPosition();
        runMobileTogglePosition();
      };

      const onResize = () => {
        runLayoutSync();
        runOverflow();
      };

      window.addEventListener('resize', onResize, { signal, passive: true });
      window.addEventListener('load', runLayoutSync, { signal, passive: true });
      window.addEventListener('scroll', runMobileTogglePosition, { signal, passive: true });
      document.fonts?.ready?.then(runLayoutSync).catch(() => {});

      for (let i = 0; i < this.dropdowns.length; i += 1) {
        const item = this.dropdowns[i];
        const align = () => {
          if (!isMobile()) {
            requestAnimationFrame(() => {
              this.syncNavMenuColumns();
              lockDropdownLayout(item);
              positionDropdown(this.scope, this.dropdowns, item);
            });
          }
        };
        item.addEventListener('mouseenter', align, { signal, passive: true });
        item.addEventListener('focusin', align, { signal });
        item.addEventListener(
          'mouseleave',
          (e) => {
            if (isMobile()) return;
            const wrap = this.q(SEL.childWrapper, item);
            if (wrap?.contains(e.relatedTarget)) return;
            if (hasNavOpen(wrap)) return;
            unlockDropdownLayout(item);
          },
          { signal }
        );
      }

      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(runOverflow);
        this.parents.forEach((parent) => {
          const wrap = this.q(SEL.childWrapper, parent);
          if (wrap) this.resizeObserver.observe(wrap);
        });
        signal.addEventListener('abort', () => this.resizeObserver?.disconnect());
      }

      runOverflow();
      runMobileTogglePosition();
    }

    bindDrawer(signal) {
      this.setDrawer = (open) => {
        this.toggle?.setAttribute('aria-expanded', String(open));
        this.toggle?.classList.toggle(CLS.active, open);
        this.drawer.classList.toggle(CLS.menuOpen, open);
        this.menu.classList.toggle(CLS.menuOpen, open);
        document.documentElement.classList.toggle(CLS.drawerOpen, open);
        if (this.externalToggle) {
          this.externalToggle.setAttribute('aria-expanded', String(open));
          if (open) {
            this.externalToggle.setAttribute('open', '');
          } else {
            this.externalToggle.removeAttribute('open');
          }
        }
        if (!open) this.collapseSubmenus(this.menu);
      };

      this.toggle?.addEventListener('click', () => this.setDrawer(!this.drawer.classList.contains(CLS.menuOpen)), {
        signal,
      });
      this.externalToggle?.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          this.setDrawer(!this.drawer.classList.contains(CLS.menuOpen));
        },
        { signal }
      );
      this.closeBtn?.addEventListener('click', () => this.setDrawer(false), { signal });
    }

    bindNavToggle(signal) {
      this.root.addEventListener(
        'click',
        (e) => {
          const overlayBtn = e.target.closest(SEL.colOverlayToggle);
          if (overlayBtn && this.root.contains(overlayBtn)) {
            e.preventDefault();
            e.stopPropagation();
            const content = overlayBtn.closest(SEL.navContent);
            const list = content?.querySelector(SEL.navMenu);
            const activeItem = list?.querySelector(`.${CLS.overlayActive}`);
            activeItem?.querySelector(SEL.navToggle)?.click();
            return;
          }

          const btn = e.target.closest(SEL.navToggle);
          if (!btn || !this.root.contains(btn)) return;
          if (btn.closest(SEL.colOverlay)) return;
          e.preventDefault();
          e.stopPropagation();

          const item = btn.closest(SEL.navItem);
          if (!item || item.classList.contains(CLS.closing)) return;

          const { sub, list, panel } = parts(item);
          const opening = !item.classList.contains(CLS.open);
          const dropdown = item.closest(SEL.dropdownParent);
          const navParent = getNavParent(item);
          const overlay = usesOverlay(list);

          this.closeOthersInList(list, opening ? item : null);

          if (!opening) {
            if (overlay) {
              this.closeOverlayItem(item, list, dropdown);
            } else {
              const { sub, btn, panel } = parts(item);
              btn?.setAttribute('aria-expanded', 'false');
              if (sub) {
                sub.classList.remove(CLS.scrollable, CLS.scrollbarVisible);
                sub.style.removeProperty('--autify-sub-available');
                sub.setAttribute('aria-hidden', 'true');
              }
              setDimmed(list, null, false);
              item.classList.remove(CLS.open);
              item.classList.add(CLS.closing);
              btn?.blur();
              this.afterClose(item, list, panel);
            }
            return;
          }

          if (!isMobile() && dropdown) {
            this.syncNavMenuColumns();
            lockDropdownLayout(dropdown);
          }

          item.classList.remove(CLS.closing);
          item.classList.add(CLS.open);
          btn.setAttribute('aria-expanded', 'true');
          setSubOpen(navParent, true);

          if (overlay) {
            if (sub) sub.setAttribute('aria-hidden', 'false');
            openColOverlay(item, list);
            return;
          }

          if (sub) {
            sub.classList.remove(CLS.scrollable, CLS.scrollbarVisible);
            sub.style.removeProperty('--autify-sub-available');
            sub.setAttribute('aria-hidden', 'false');
          }
          setDimmed(list, item, true);

          if (!isMobile()) {
            const measure = () => this.syncSubOverflow(item, sub, panel);
            if (mqReduced.matches || !panel) {
              requestAnimationFrame(measure);
            } else {
              waitPanel(panel, measure);
            }
          }
        },
        { signal }
      );
    }

    bindDesktop(signal) {
      if (isMobile()) return;

      this.menu.addEventListener(
        'mouseleave',
        (e) => {
          if (isMobile()) return;
          if (this.menu.contains(e.relatedTarget)) return;
          this.deactivateAllParents();
        },
        { signal }
      );

      for (let i = 0; i < this.parents.length; i += 1) {
        const parent = this.parents[i];
        const wrap = this.q(SEL.childWrapper, parent);
        const link = parent.querySelector(':scope > a');

        const activate = () => {
          if (isMobile()) return;
          this.activateParent(parent);
        };

        parent.addEventListener('mouseenter', activate, { signal, passive: true });
        link?.addEventListener('mouseenter', activate, { signal, passive: true });

        wrap?.addEventListener(
          'mouseleave',
          (e) => {
            if (isMobile()) return;
            if (!wrap) return;
            if (wrap.contains(e.relatedTarget)) return;
            if (hasNavOpen(wrap)) return;
            clearTimeout(this.leaveTimer);
            const x = e.clientX;
            const y = e.clientY;
            this.leaveTimer = setTimeout(() => {
              if (isMobile()) return;
              if (hasNavOpen(wrap)) return;
              if (wrap.matches(':hover')) return;
              const atPointer = document.elementFromPoint(x, y);
              if (atPointer && wrap.contains(atPointer)) return;
              this.closeSubmenusAnimated(wrap);
              this.blurFocus(wrap);
              unlockDropdownLayout(parent);
            }, 80);
          },
          { signal }
        );
      }
    }

    hasNavigableHref(link) {
      if (!link) return false;
      const href = (link.getAttribute('href') || '').trim();
      return href !== '' && href !== '#' && href !== '/#';
    }

    setParentAccordion(parent, open) {
      if (!parent) return;
      parent.classList.toggle(CLS.active, open);
      const toggle = parent.querySelector(SEL.parentToggle);
      toggle?.setAttribute('aria-expanded', String(open));
      if (!open) {
        this.collapseTitles(parent);
        this.collapseSubmenus(parent);
      }
    }

    toggleParentAccordion(parent) {
      if (!parent) return;
      const wasActive = parent.classList.contains(CLS.active);
      const actives = this.qa(`${SEL.navParent}.${CLS.active}`, this.menu);
      for (let i = 0; i < actives.length; i += 1) {
        this.setParentAccordion(actives[i], false);
      }
      if (!wasActive) this.setParentAccordion(parent, true);
    }

    bindMobile(signal) {
      this.menu.addEventListener(
        'click',
        (e) => {
          if (!isMobile()) return;

          const title = e.target.closest(SEL.titledTitle);
          if (title) {
            title.closest('.child-column--has-title')?.classList.toggle(CLS.active);
            return;
          }

          const toggle = e.target.closest(SEL.parentToggle);
          if (toggle && this.menu.contains(toggle)) {
            e.preventDefault();
            this.toggleParentAccordion(toggle.closest(SEL.navParent));
            return;
          }

          const link = e.target.closest(SEL.parentLink);
          if (!link || !this.menu.contains(link)) return;

          // Real URL → navigate. No link / # → expand/collapse.
          if (this.hasNavigableHref(link)) return;

          e.preventDefault();
          this.toggleParentAccordion(link.closest(SEL.navParent));
        },
        { signal }
      );
    }

    bindViewport(signal) {
      const onChange = () => {
        if (!isMobile()) this.setDrawer(false);
        this.refreshLayoutCaches();
        this.qa(`${SEL.navParent}.${CLS.active}`, this.menu).forEach((el) => this.setParentAccordion(el, false));
        this.collapseTitles(this.menu);
        this.collapseSubmenus(this.menu);
        cancelAnimationFrame(this.posFrame);
        this.posFrame = requestAnimationFrame(() => {
          if (!isMobile()) positionDropdown(this.scope, this.dropdowns);
        });
      };

      mqMobile.addEventListener?.('change', onChange, { signal }) ?? mqMobile.addListener(onChange);
    }

    bindEscape(signal) {
      document.addEventListener(
        'keydown',
        (e) => {
          if (e.key !== 'Escape' || !this.root.isConnected) return;
          if (this.drawer.classList.contains(CLS.menuOpen)) {
            this.setDrawer(false);
            this.toggle.focus();
            return;
          }
          if (!isMobile() && this.q(SEL.navOpen)) {
            this.closeSubmenusAnimated(this.root);
            this.blurFocus(this.root);
          }
        },
        { signal }
      );
    }

    activateParent(parent) {
      if (isMobile() || !parent) return;
      for (let i = 0; i < this.parents.length; i += 1) {
        const p = this.parents[i];
        if (p === parent) {
          p.classList.add(CLS.menuActive);
          continue;
        }
        closeParentMenu(p);
      }
    }

    deactivateAllParents() {
      if (isMobile()) return;
      for (let i = 0; i < this.parents.length; i += 1) {
        closeParentMenu(this.parents[i]);
      }
    }

    collapseTitles(scope) {
      scope.querySelectorAll(SEL.titledActive).forEach((el) => el.classList.remove(CLS.active));
    }

    collapseSubmenus(scope) {
      if (scope.matches?.('.nav-parent.has-children')) {
        closeParentMenu(scope);
        return;
      }
      scope.querySelectorAll('.nav-parent.has-children').forEach((parent) => closeParentMenu(parent));
    }

    blurFocus(scope) {
      scope.querySelectorAll(SEL.focusable).forEach((el) => el.blur());
    }

    closeOthersInList(list, keep) {
      if (!list?.classList.contains(CLS.navMenu)) return;
      const open = list.querySelectorAll(':scope > li.autify-nav-menu__item--has-children.is-open');
      for (let i = 0; i < open.length; i += 1) {
        if (open[i] !== keep) resetItem(open[i]);
      }
    }

    closeItemInstant(item, list) {
      item.classList.add(CLS.instantClose);
      resetItem(item);
      setDimmed(list, null, false);
      requestAnimationFrame(() => item.classList.remove(CLS.instantClose));
    }

    closeOverlayItem(item, list, dropdown) {
      const { sub, btn } = parts(item);
      btn?.setAttribute('aria-expanded', 'false');
      btn?.blur();
      item.classList.remove(CLS.open, CLS.overlayActive);
      if (sub) sub.setAttribute('aria-hidden', 'true');

      closeColOverlay(list, {
        onDone: () => {
          if (dropdown && !hasNavOpen(list)) {
            unlockDropdownLayout(dropdown);
            this.scheduleColSync();
          }
        },
      });
    }

    scheduleColSync() {
      clearTimeout(this.colSyncTimer);
      this.colSyncTimer = setTimeout(() => this.syncNavMenuColumns(), PANEL_MS);
    }

    closeSubmenusAnimated(scope) {
      const items = scope.querySelectorAll(SEL.navOpen);
      if (!items.length) return;

      for (let i = 0; i < items.length; i += 1) {
        const item = items[i];
        const { sub, btn, list, panel } = parts(item);

        if (usesOverlay(list)) {
          resetItem(item);
          if (btn) btn.blur();
          continue;
        }

        if (sub) {
          sub.classList.remove(CLS.scrollable, CLS.scrollbarVisible);
          sub.style.removeProperty('--autify-sub-available');
          sub.setAttribute('aria-hidden', 'true');
        }
        if (btn) {
          btn.setAttribute('aria-expanded', 'false');
          btn.blur();
        }

        if (isMobile()) {
          item.classList.remove(CLS.open, CLS.closing);
          continue;
        }

        item.classList.remove(CLS.open);
        item.classList.add(CLS.closing);
        this.afterClose(item, list, panel);
      }
    }

    afterClose(item, list, panel) {
      const dropdown = item.closest('.nav-parent--dropdown');
      const finish = () => {
        item.classList.remove(CLS.closing);
        setDimmed(list, null, false);
        if (list && !hasNavOpen(list)) closeColOverlay(list, { instant: true });
        updateSubOpenState(getNavParent(item));
        if (dropdown && !dropdown.querySelector(SEL.navOpen)) {
          unlockDropdownLayout(dropdown);
          this.scheduleColSync();
        }
      };
      if (!panel || isMobile()) {
        finish();
        return;
      }
      waitPanel(panel, finish);
    }

    syncAllOpenOverflow() {
      if (isMobile()) return;
      this.qa(SEL.navOpen).forEach((item) => {
        const { sub, panel, list } = parts(item);
        if (usesOverlay(list)) return;
        if (sub) this.syncSubOverflow(item, sub, panel);
      });
    }

    syncNavMenuColumns() {
      const lists = this.qa(SEL.navMenuInColumn);
      for (let i = 0; i < lists.length; i += 1) {
        const list = lists[i];
        const hasActive = !!list.querySelector(SEL.navActive);

        if (hasActive) continue;

        if (applyLockedCols(list)) continue;

        list.classList.remove(CLS.twoCols);
        list.style.removeProperty('--autify-nav-two-cols-max');

        if (isMobile()) continue;

        const rect = list.getBoundingClientRect();
        const viewportAvailable = Math.floor(window.innerHeight - rect.top - 24);
        const available = Math.max(220, viewportAvailable);
        if (list.scrollHeight > available) {
          list.classList.add(CLS.twoCols);
          list.style.setProperty('--autify-nav-two-cols-max', `${available}px`);
        }
      }
    }

    syncMobileTogglePosition() {
      if (!this.toggle) return;

      if (!this.headerSection?.isConnected) this.refreshLayoutCaches();

      const headerHeight = this.headerSection ? this.headerSection.offsetHeight : 100;

      let announcementVisible = 0;
      if (this.announcementSection?.isConnected) {
        const rect = this.announcementSection.getBoundingClientRect();
        announcementVisible = Math.max(0, Math.min(rect.bottom, rect.height));
      }

      const top = announcementVisible + headerHeight / 2;
      this.toggle.style.top = `${Math.round(top)}px`;
    }

    syncSubOverflow(item, sub, panel) {
      if (!item?.classList.contains(CLS.open) || !sub) return;

      sub.classList.remove(CLS.scrollable, CLS.scrollbarVisible);

      const wrap = item.closest(SEL.childWrapper);
      const row = item.querySelector(SEL.row);
      if (wrap && row) {
        const available = Math.floor(wrap.getBoundingClientRect().bottom - row.getBoundingClientRect().bottom - OVERFLOW_PAD);
        if (available > MIN_SUB_HEIGHT) {
          sub.style.setProperty('--autify-sub-available', `${available}px`);
        } else {
          sub.style.removeProperty('--autify-sub-available');
        }
      }

      void sub.offsetHeight;
      const overflows = sub.scrollHeight > sub.clientHeight + 2;
      if (!overflows) return;

      sub.classList.add(CLS.scrollable, CLS.scrollbarVisible);
    }

    destroy() {
      clearTimeout(this.leaveTimer);
      clearTimeout(this.colSyncTimer);
      cancelAnimationFrame(this.posFrame);
      cancelAnimationFrame(this.overflowFrame);
      cancelAnimationFrame(this.mobileFrame);
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      inited.delete(this.root);
      delete this.root._autifyMenu;
    }
  }

  function init(root) {
    root._autifyMenu?.destroy();

    const instance = new AutifyMegaMenu(root);
    if (!instance.mount()) return;

    inited.add(root);
    root._autifyMenu = instance;
  }

  function boot(event) {
    const roots = event?.target
      ? event.target.querySelectorAll(SEL.root)
      : document.querySelectorAll(SEL.root);
    roots.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
